import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export function FaqList({ items, title = "Häufige Fragen" }: { items: { q: string; a: string }[]; title?: string }) {
  return (
    <section className="border-b border-[var(--rule)] surface-linen">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-14 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-4">
          <div className="eyebrow text-[var(--leaf)] mb-3">FAQ</div>
          <h2 className="font-display text-2xl md:text-4xl leading-tight text-[var(--ink)]">{title}</h2>
        </div>
        <div className="md:col-span-7 md:col-start-6">
          <Accordion type="single" collapsible className="border-t border-[var(--rule)]">
            {items.map((it, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-[var(--rule)]">
                <AccordionTrigger className="text-base md:text-lg font-display text-[var(--ink)] py-5">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-[var(--ink)]/80 leading-relaxed">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
